import React, { ReactElement } from 'react';
import { ModeleHoraire } from '../../../../../common/src/entities/modele-horaire.entity';
import ChampMultiple, { affichageElementDefaut } from '../../Common/ChampMultiple';
import { ArrayHelpers } from 'formik';
import { useAlertDialog } from '../../../Utils/dialogContext';
import { PopoutEntite } from '../Utils/PopoutEntite';
import CreerModeleHoraire from './CreerModeleHoraire';
import { ValueType } from 'react-select';
import { Col, Row } from 'react-bootstrap';
import { cssTexte } from '../constantes';

interface PropsAffichageAjoutModeleHoraire {
    helpers: ArrayHelpers;
    values: ModeleHoraire[];
    title?: string;
    maxSize?: number;
    onChange?: (modeleHoraire: ModeleHoraire) => void;
}

function AffichageAjoutModeleHoraire(props: PropsAffichageAjoutModeleHoraire): ReactElement {
    const bsAlert = useAlertDialog();

    function gererOnChange(value: ValueType<ModeleHoraire, false>): void {
        const modeleHoraire = value as ModeleHoraire;
        if (!modeleHoraire) return;

        if (props.values.find((item) => item.id === modeleHoraire.id)) {
            bsAlert("Ce modèle d'horaire est déjà associé!", 'warning');
            return;
        } else if (props.maxSize && props.values.length === props.maxSize) {
            bsAlert(`Vous ne pouvez qu'ajouter un max de ${props.maxSize} élément(s)`, 'warning');
            return;
        }
        props.helpers.push(modeleHoraire);
        if (props.onChange) props.onChange(modeleHoraire);
    }

    return (
        <PopoutEntite
            titre={`Ajouter un ${props.title?.toLowerCase() ?? "modèle d'horaire"}`}
            entite={ModeleHoraire}
            modalSize="lg"
            modalBody={(props) => <CreerModeleHoraire {...props} />}
            size="sm"
            isCreatable
            disabled={props.maxSize === props.values.length ? true : false}
            getOptionLabel={(option) => option.name}
            onChange={gererOnChange}
        />
    );
}

const AffichageElement = (props: {
    value: ModeleHoraire;
    index: number;
    helpers: ArrayHelpers;
    affichageTexte: (value: ModeleHoraire | number) => string;
}): ReactElement => {
    const { value, affichageTexte } = props;

    return (
        <Row>
            <Col className="d-flex align-items-center ml-2">
                <span style={cssTexte}>{affichageTexte(value)}</span>
            </Col>
        </Row>
    );
};

const affichageElement = (
    value: ModeleHoraire,
    index: number,
    helpers: ArrayHelpers,
    affichageTexte: (value: ModeleHoraire | number) => string,
) => <AffichageElement {...{ value, index, helpers, affichageTexte }} />;

export interface PropsChampMultipleModelesHoraire {
    id: string;
    labelCol?: number;
    maxSize?: number;
    title?: string;
    onChange?: (modeleHoraire: ModeleHoraire) => void;
}

export default function ChampMultipleModelesHoraire(props: PropsChampMultipleModelesHoraire): ReactElement {
    const affichageAjoutModeleHoraire = (values, helpers, maxSize?: number, title?: string) => (
        <AffichageAjoutModeleHoraire
            helpers={helpers}
            values={values}
            maxSize={maxSize}
            title={title}
            onChange={props.onChange}
        />
    );

    const affichageTexte = (modeleHoraire: ModeleHoraire | number) => (modeleHoraire as ModeleHoraire).name;

    return (
        <ChampMultiple
            entite={ModeleHoraire}
            titre={`${props.title ?? "Modèles d'horaire"}`}
            {...props}
            affichageAjout={affichageAjoutModeleHoraire}
            affichageTexte={affichageTexte}
            affichageElement={affichageElementDefaut(ModeleHoraire)}
            labelCol={props.labelCol}
            onChange={props.onChange}
        />
    );
}
